var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Bluebird from "bluebird";
import h from "../helper/helper";
import Progress from "../asset/Progress";
import blobService, { unpath } from "./blobService";
import blobCache from "../asset/blobCache";
import Queue from '../asset/Queue';
import { queue as fileTransferQueue } from './fileTransferQueue';
var defaultUploadOptions = {
    encrypt: true,
    extraInfo: {}
};
var encryptionQueue = new Queue(500 * 1000);
encryptionQueue.start();
var FileUpload = /** @class */ (function () {
    function FileUpload(file, options) {
        var _this = this;
        this.file = file;
        this.getProgress = function () {
            return _this.progress.getProgress();
        };
        this.uploadAndEncryptPreparedBlob = function (encryptionKey, blob) {
            _this.progress.addDepend(blob.uploadProgress);
            _this.progress.addDepend(blob.encryptProgress);
            return encryptionQueue.enqueue(blob.getSize(), function () {
                return blob.encryptAndUpload(encryptionKey);
            });
        };
        this.uploadPreparedBlob = function (blob) {
            _this.progress.addDepend(blob.uploadProgress);
            return blob.upload();
        };
        this.upload = function (encryptionKey) {
            if (!_this.blob) {
                throw new Error("usage error: prepare was not called!");
            }
            return fileTransferQueue.enqueue(1, function () {
                console.info("Uploading blob");
                if (_this.options.encrypt) {
                    return _this.uploadAndEncryptPreparedBlob(encryptionKey, _this.blob);
                }
                return _this.uploadPreparedBlob(_this.blob);
            }).then(function (keys) {
                if (_this.file.originalUrl) {
                    var _a = unpath(_this.file.originalUrl), directory = _a.directory, name_1 = _a.name;
                    return blobCache.moveFileToBlob(directory, name_1, _this.blob.getBlobID()).then(function () { return keys; });
                }
                return keys;
            });
        };
        this.prepare = h.cacheResult(function () {
            return FileUpload.blobToDataSet(_this.blob).then(function (data) {
                data.content = __assign({}, data.content, _this.getInfo());
                return data;
            });
        });
        this.getInfo = function () {
            return __assign({ name: _this.file.name, size: _this.file.size, type: _this.file.type }, _this.options.extraInfo);
        };
        this.getFile = function () {
            return _this.file;
        };
        this.getName = function () {
            return _this.file.name;
        };
        this.progress = new Progress();
        this.blob = blobService.createBlob(file);
        this.options = options || defaultUploadOptions;
    }
    FileUpload.blobToDataSet = function (blob) {
        return Bluebird.all([blob.preReserveID(), blob.getHash()]).spread(function (blobID, hash) {
            return {
                blob: blob,
                content: {
                    blobHash: hash
                },
                meta: {
                    blobID: blobID
                }
            };
        });
    };
    FileUpload.fileCallback = function (cb) {
        return function (e) {
            cb(Array.prototype.slice.call(e.target.files));
            try {
                e.target.value = null;
            }
            catch (ex) {
                console.log(ex);
            }
        };
    };
    return FileUpload;
}());
export default FileUpload;



//////////////////
// WEBPACK FOOTER
// ./js/services/fileUpload.service.ts
// module id = null
// module chunks = 